import useInquiry from "../modules/inquiry/hooks";
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody
} from "shards-react";

import PageTitle from "../components/common/PageTitle";

import Pagination from "../components/inquiry/pagination";

const Tables = () => {
  const [modalOpen, setModalOpen] = useState();
  const [modalData, setModalData] = useState({});
  const { fetchAllInquiry, inquiry, totalLength, pageNumber } = useInquiry();
  useEffect(() => {
    if (totalLength !== 0) return;
    fetchAllInquiry();
    
  }, []);

  const onChange = item => () => {
    setModalData(item);
    setModalOpen(prev => !prev);
  };

  return (
    <Container fluid className="main-content-container px-4">
      {/* Page Header */}
      <Row noGutters className="page-header py-4">
        <PageTitle
          sm="4"
          title="문의 사항"
          
          className="text-sm-left"
        />
      </Row>

      {/* Default Light Table */}
      <Row>
        <Col>
          <Card
            small
            className="mb-4"
            style={{ position: "relative", height: "650px" }}
          >
            <CardHeader className="border-bottom">
              <h6 className="m-0">문의 내역</h6>
            </CardHeader>
            <CardBody className="p-0 pb-5">
              <table className="table mb-0">
                <thead className="bg-light">
                  <tr>
                    <th scope="col" className="border-0" style={{paddingLeft:"30px"}}>
                      #
                    </th>
                    <th scope="col" className="border-0">
                      이름
                    </th>
                    <th scope="col" className="border-0">
                      회사명(선택)
                    </th>
                    <th scope="col" className="border-0">
                      이메일
                    </th>
                    <th scope="col" className="border-0">
                      연락처
                    </th>
                    <th scope="col" className="border-0">
                      문의사항
                    </th>
                    <th scope="col" className="border-0">
                      문의일자
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {inquiry.map((item, index) => (
                    <tr
                      style={{ cursor: "pointer" }}
                      onClick={onChange(item)}
                      key={item.id}
                    >
                      
                      <td style={{paddingLeft:"30px"}}>{totalLength -  (pageNumber - 1) * 10 - index}</td>
                      <td>{item.name}</td>
                      <td>{item.company}</td>
                      <td>{item.email}</td>
                      <td>{item.contact}</td>
                      <td>
                        {item.message.slice(0, 40) +
                          (item.message.length > 40 ? "..." : "")}
                      </td>
                      <td>{item.regdate}</td>
                    </tr>
                  ))}
                </tbody>
                <Modal open={modalOpen} centered={true}>
                  <ModalHeader className="d-block">
                    문의사항
                    <div
                      onClick={onChange({})}
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        right: "1rem",
                        top: "1rem"
                      }}
                    >
                      <i className="material-icons">close</i>
                    </div>
                  </ModalHeader>
                  <ModalBody>
                    <Row>
                      <Col md="3">
                        <strong className="text-muted">이름</strong>
                      </Col>
                      <p>{modalData.name}</p>
                    </Row>
                    <Row>
                      <Col md="3">
                        <strong className="text-muted">회사명</strong>
                      </Col>
                      <p>{modalData.company}</p>
                    </Row>
                    <Row>
                      <Col md="3">
                        <strong className="text-muted">이메일</strong>
                      </Col>
                      <p>{modalData.email}</p>
                    </Row>
                    <Row>
                      <Col md="3">
                        <strong className="text-muted">연락처</strong>
                      </Col>
                      <p>{modalData.contact}</p>
                    </Row>
                    <Row>
                      <Col md="3">
                        <strong className="text-muted">문의사항</strong>
                      </Col>
                      <Col md="9" style={{ paddingLeft: 0 }}>
                        <p>{modalData.message}</p>
                      </Col>
                    </Row>
                  </ModalBody>
                </Modal>
              </table>
            </CardBody>
            <Pagination
              style={{ 
                display:"flex",
                position: "absolute", bottom: 10,  
                justifyContent:'center'
              }}
            />
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Tables;
